
namespace GeniuzPOS.Administration {

    @Serenity.Decorators.registerClass()
    export class PsPosFuncDialog extends Serenity.EntityDialog<PsPosFuncRow, any> {
        protected getFormKey() { return PsPosFuncForm.formKey; }
        protected getIdProperty() { return PsPosFuncRow.idProperty; }
        protected getLocalTextPrefix() { return PsPosFuncRow.localTextPrefix; }
        protected getNameProperty() { return PsPosFuncRow.nameProperty; }
        protected getService() { return PsPosFuncService.baseUrl; }
        protected getDeletePermission() { return PsPosFuncRow.deletePermission; }
        protected getInsertPermission() { return PsPosFuncRow.insertPermission; }
        protected getUpdatePermission() { return PsPosFuncRow.updatePermission; }

        protected form = new PsPosFuncForm(this.idPrefix);

    }
}